var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"title":"Gebäudestruktur"}},[_c('Section',[_c('Card',{attrs:{"title":"Struktur"}},[_c('PropertyStructure',{attrs:{"propertyId":_vm.propertyId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }